import config from "@shared/config/client";
import { Follow } from "./types";
import { ICallableRequestBuilder } from "../requestBuilder/types";

const getFolloweesByUser =
  (request: ICallableRequestBuilder<Follow[]>) =>
  async (followerId: string, skip: number, take: number) => {
    return request.call(
      `${config.apiUrl}/follows/followees/${followerId}?skip=${skip}&take=${take}`,
    );
  };

const getFollowersByUser =
  (request: ICallableRequestBuilder<Follow[]>) =>
  async (followeeId: string, skip: number, take: number) => {
    return request.call(
      `${config.apiUrl}/follows/followers/${followeeId}?skip=${skip}&take=${take}`,
    );
  };

const getFollowersCount =
  (request: ICallableRequestBuilder<number>) => (userId: string) => {
    return request.call(`${config.apiUrl}/follows/followers-count/${userId}`);
  };

const getFollowingCount =
  (request: ICallableRequestBuilder<number>) => (userId: string) => {
    return request.call(`${config.apiUrl}/follows/following-count/${userId}`);
  };

const requests = {
  getFolloweesByUser,
  getFollowersByUser,
  getFollowersCount,
  getFollowingCount,
};

export default requests;
